import React, { useContext } from 'react';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';
import { CheckoutContext } from '../eir-checkout/EirCheckoutContainer';
import moment from 'moment';

export const useFetchDate = () => {
    const graphql = useApolloClient();
    const [portinMinDate, setPortinMinDate] = React.useState(null);
    const [portinMaxDate, setPortinMaxDate] = React.useState(null);
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [minDate, setMindate] = React.useState(null);
    const [maxDate, setMaxdate] = React.useState(null);
    const [startingTime, setStartingTime] = React.useState(null);
    const [endingTime, setEndingTime] = React.useState(null);
    const [timeRangeError, setTimeRangeError] = React.useState('');
    const [selctedDatewithoutTimeZone, setselctedDatewithoutTimeZone] = React.useState(null);
    const { cartDetails } = useContext(CheckoutContext);
    // to selcted min date ,max date ,min time, max time
    React.useEffect(() => {
        const fetchData = async () => {
            if (cartDetails.port) {
                const portDate = cartDetails.port.portStartDateTime.split('T')[0];
                setselctedDatewithoutTimeZone(portDate);
            }
            try {
                const res = await graphql.query({
                    query: ENDPOINT.GET_PORTING_DATE_TIME,
                    variables: { brand: 'EIR', channel: 'ESHOP' },
                });
                if (res.data.portingTime) {
                    const portinSlotList = res.data.portingTime.portingHours;
                    const portinSlotDateList = portinSlotList.map(
                        portinSlot => new Date(portinSlot.date)
                    );
                    if (selectedDate != null) {
                        var selectedConvertedDate = moment(selectedDate).format('YYYY-MM-DD');
                        setselctedDatewithoutTimeZone(selectedConvertedDate);
                        var portinSlotDateTimeList = portinSlotList.find(
                            portinSlot => portinSlot.date === selectedConvertedDate
                        );
                        var startingTime = new Date(portinSlotDateTimeList.startTime);
                        var endTime = new Date(portinSlotDateTimeList.endTime);
                        startingTime =
                            (startingTime.getHours() < 10
                                ? '0' + startingTime.getHours()
                                : startingTime.getHours()) +
                            ':' +
                            (startingTime.getMinutes() < 10
                                ? '0' + startingTime.getMinutes()
                                : startingTime.getMinutes());
                        endTime =
                            (endTime.getHours() < 10
                                ? '0' + endTime.getHours()
                                : endTime.getHours()) +
                            ':' +
                            (endTime.getMinutes() < 10
                                ? '0' + endTime.getMinutes()
                                : endTime.getMinutes());
                        setStartingTime(startingTime);
                        setEndingTime(endTime);
                        setTimeRangeError(`Must be after ${startingTime} and before ${endTime}`);
                    }

                    var maximumDate = new Date(Math.max.apply(null, portinSlotDateList));
                    setMaxdate(maximumDate);
                    maximumDate =
                        maximumDate.getDate() +
                        '/' +
                        (maximumDate.getMonth() + 1) +
                        '/' +
                        maximumDate.getFullYear();
                    var minimumDate = new Date(Math.min.apply(null, portinSlotDateList));
                    setMindate(minimumDate);
                    minimumDate =
                        minimumDate.getDate() +
                        '/' +
                        (minimumDate.getMonth() + 1) +
                        '/' +
                        minimumDate.getFullYear();
                    setPortinMinDate(minimumDate);
                    setPortinMaxDate(maximumDate);
                }
            } catch (error) {
                //handle error here
            }
        };
        fetchData();
    }, [selectedDate]);

    const handleDateChange = date => {
        if (date == null) {
            setSelectedDate(null);
        } else {
            setSelectedDate(date);
        }
    };
    return [
        minDate,
        maxDate,
        selectedDate,
        handleDateChange,
        startingTime,
        endingTime,
        timeRangeError,
        selctedDatewithoutTimeZone,
    ];
};
